<template>
  <div class="layout">
    <Header />
    <el-row class="nav-title">
      <Nav />
    </el-row>
    <div class="concent">
      <slot></slot>
    </div>
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '../header/header'
import Nav from '../nav/nav'
import Footer from '../footer/footer'
export default {
  components: {
    Header,
    Nav,
    Footer
  }
}
</script>

<style scoped lang="stylus">
.layout
  width 100%
  overflow-x hidden
  min-width 1200px
  height 100%
  .nav-title
    background rgba(44, 47, 58, .7)
    position absolute
    top 59px
    left 0
    right 0
    z-index 10
</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue